export const sxConfig = (chipBg) => {
  return {
    tableContainerBox: {
      backgroundColor: '#F5F5F5',
      height: 'calc(100vh - 65px)',
      pt: '0.1rem',
    },
    table: {
      tableLayout: 'fixed',
      width: '100%',
    },
    firstRowFirstTableCell: {
      width: '350px',
      minWidth: '350px',
      maxWidth: '350px',
      backgroundColor: 'white',
      fontWeight: 'bold',
      fontSize: '1.1rem',
      border: '1px solid #ccc',
      color: '#667280',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    firstRowSecondTableCell: {
      backgroundColor: '#F5F5F5',
      border: '1px solid #ccc',
      padding: '0.5rem 0.5rem 0rem 0.5rem',
      overflow: 'hidden',
    },
    secondRowFirstTableCell: {
      width: '350px',
      minWidth: '350px',
      maxWidth: '350px',
      backgroundColor: 'white',
      border: '1px solid #ccc',
      color: '#667280',
      fontSize: '1rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    scrollableBox: {
      overflowX: 'auto',
      width: '100%',
    },
    stack: {
      display: 'flex',
      flexDirection: 'row',
      gap: '0.5rem',
      width: 'fit-content',
    },
    chipContainerBox: {
      backgroundColor: chipBg?.colorBgCode,
      color: chipBg?.textColor,
      px: 2,
      py: 1,
      borderRadius: '16px',
      minWidth: 'fit-content',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    chipTypography: {
      fontWeight: 'bold',
    },
    chipPeopleIcon: {
      marginRight: '0.2rem',
    },
  };
};
